<script>
import similarVideos from "../../components/similarVideos.vue";
import { getMovies } from "../../Api";
import ElButton from "../../components/ElButton";
export default {
    name: "NotFoundPage",

    components: { similarVideos, ElButton },

    data() {
        return {
            recommendMovies: [],
        };
    },

    mounted() {
        this.getRecommendMovies();
    },

    methods: {
        async getRecommendMovies() {
            const params = {
                cgid: "260",
                season: "0",
            };

            let movies = await getMovies(this.isLoggedIn, {
                page: 1,
                limit: 12,
                ...params,
                lang: this.$i18n.locale == "uz" ? "fr" : "ru",
            });

            this.recommendMovies = movies;
        },
    },
};
</script>

<template>
    <img src="../../../assets/assets/page_not_found.png" alt="Tvcom" />

    <div class="page_wrap">
        <div class="img_wrap">
            <div class="not_found_wrap">
                <h2>404</h2>
                <span>{{ $t("message.pageNotFound") }}</span>
                <ElButton
                    size="medium"
                    type="default"
                    @click="$router.push({ name: 'home' })"
                >
                    {{ $t("message.mainPage") }}
                </ElButton>
                <!-- <a href="/" class="btn">{{ $t("message.mainPage") }}</a> -->
            </div>
        </div>

        <!-- SIMILAR section -->
        <div class="similar_movie_section container">
            <div class="section_title_wrap similar_movie_title_wrap">
                <h4>{{ $t("message.recommend") }}</h4>
            </div>

            <similarVideos v-if="recommendMovies" :content="recommendMovies" />
        </div>
        <!-- --//-- SIMILAR section -->
    </div>
</template>

<style scoped>
.page_wrap {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    width: 100%;
    position: relative;
    margin-bottom: 2rem;
    padding-top: calc(50vh - 138px);
    gap: 30px;
}

.img_wrap {
    position: relative;
    width: 100%;
}

img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: fixed;
    bottom: 0;
    top: 0;
}

.not_found_wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 14px;
}

.not_found_wrap > h2 {
    font-size: 10rem;
    letter-spacing: 20px;
    opacity: 0.5;
    line-height: 8rem;
}

.not_found_wrap > span {
    font-size: 2rem;
    opacity: 0.5;
}

.btn {
    border: none;
    padding: 10px 14px;
    font-size: 18px;
    background: #e11f4b;
    color: #fff;
    border-radius: 6px;
    cursor: pointer;
    opacity: 0.8;
    transition: 0.2s;
}

.btn:hover {
    opacity: 0.6;
}

.container {
    width: 88%;
    /* position: absolute; */
    /* bottom: -2rem; */
}

.section_title_wrap {
    display: flex;
}

.section_title_wrap > h4 {
    font-size: 24px;
    font-weight: 600;
    color: #e3e3e3;
}

.similar_movie_title_wrap {
    margin-bottom: 10px;
}

/* @media screen and (max-width: 520px) {
    .not_found_wrap {
        transform: translate(-50%) scale(0.8);
    }
} */
</style>
